import React, { useState } from "react";
import Card from '@mui/material/Card';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources } from "../authConfig";
import { ReportsGrid } from "./ReportsGrid";
import LoadingSpinner from "./LoadingSpinner";
import ShowToast from '../components/ShowToast.jsx';
import PropTypes from 'prop-types';

export const ReportsView = ({ administrator }) => {
    ReportsView.propTypes = {
        administrator: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.oneOf([null])
        ])
    };

    const { error, isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.api.scopes
    });

    if (error) {
        ShowToast("error", error?.message);
    }

    const renderForm = (
        <Card variant="outlined">
            <h2 className="tituloH2 mt-3">Registro de reportes</h2>
            <ReportsGrid administrator={administrator} />
        </Card>
    );

    return (
        <div className="container"> {isLoading ? <LoadingSpinner /> : renderForm}</div>
    );
}
